module.exports = __webpack_public_path__ + "6d72813245eca04591cc1efec773d55b.fbx";